module.exports = __webpack_public_path__ + "img/trainings-1440_new.f86d58d6.jpg";